import React from 'react'
import SlidingImages from '../Slide/SlidingImages';
import { Link } from 'react-router-dom'
import { useFirebaseData } from '../../hooks/useFirebaseData';

export default function SlidingBibleImages() {
  const { data: bannerData, loading } = useFirebaseData('banner');
  const bannerContent = bannerData[0] || {};

  if (loading) {
    return (
      <div className="flex justify-center items-center min-h-[400px]">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  return (
    <div className='relative sm:mx-auto sm:w-full' id="home">
      <SlidingImages />
      <div className='absolute hidden top-[290px] left-1/2 transform -translate-x-1/2 w-full sm:w-[750px]'>
        <div className='text-white flex flex-col sm:flex-row items-center gap-3 px-5 sm:gap-5 sm:px-10'>
          <div className='bg-white h-[1px] w-[100px] sm:w-[200px]'></div>
          <div className='font-[roboto] text-base sm:text-20px'>{bannerContent.churchName || "Eglise Evangelique des Amis au Rwanda (EEAR)"}</div>
          <div className='bg-white h-[1px] w-[100px] sm:w-[200px]'></div>
        </div>
        <div className='uppercase text-white text-[24px] sm:text-[35px] font-bold font-[roboto] my-3 sm:my-6'>
          <span>{bannerContent.mainText || "Shining the Light of"} <span className='text-[#ffd615]'>{bannerContent.highlightedText || "Christ across Rwanda"}</span> {bannerContent.subText || "and throughout the world"}</span>
        </div>
        <div className='font-[roboto] text-white text-sm sm:text-base'>
          {bannerContent.description || "Evangelical Friends Church in Rwanda is a faith-based organization that began its ministry in 1986 and was officially incorporated in 1987 in Kigali. It was founded through the efforts of missionaries from the American, Willard Ferguson and his wife Doris Ferguson, who, together with Rwandan believers, started preaching the gospel. The church emphasizes both spiritual growth and community transformation through initiatives such as education, poverty reduction, and other socio-economic programs. Over the years, the Evangelical Friends Church in Rwanda has expanded significantly, now comprising 76 local churches and operating throughout all regions of the country, with a membership of over 7,000. Church has also made a meaningful contribution to the holistic transformation and reconciliation of Rwandan society."}
        </div>
        <div className='flex flex-col sm:flex-row gap-2 px-2 sm:gap-3 sm:px-[200px] mt-4 sm:mt-12'>
          <div className='mt-2 sm:mt-0'>
            <Link to="/">
              <button type="button" className='bg-[#ffd615] rounded-full px-4 sm:px-6 font-[roboto] text-white py-2'>
                {bannerContent.primaryButtonText || "Be part of us"}
              </button>
            </Link>
          </div>
          <div className='mt-2 sm:mt-0'>
            <Link to="/">
              <button type="button" className='border border-[#ffd615] text-[#ffd615] rounded-full px-4 sm:px-6 font-[roboto hover:text-white hover:bg-[#ffd615] py-2'>
                {bannerContent.secondaryButtonText || "Read More"}
              </button>
            </Link>
          </div>
        </div>
      </div>
    </div>
  )
}
